import * as React from "react";

import { cn } from "@/shared/lib/cn";
import type { ReactNode } from "react";

export interface InputProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "prefix" | "suffix"
  > {
  prefix?: ReactNode;
  suffix?: ReactNode;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, prefix, suffix, ...props }, ref) => {
    if (!prefix && !suffix) {
      return (
        <input
          type={type}
          className={cn(
            "flex h-10 w-full rounded-xl border border-grid-200 bg-white px-3 py-2 text-sm text-ink-900 shadow-sm transition-all placeholder:text-ink-400 focus-visible:outline-none focus-visible:border-2 focus-visible:border-imperial-500 focus-visible:bg-imperial-50/30 disabled:cursor-not-allowed disabled:opacity-50",
            className
          )}
          ref={ref}
          {...props}
        />
      );
    }

    return (
      <div
        className={cn(
          "flex h-10 w-full items-center gap-2 rounded-xl border border-grid-200 bg-white px-3 py-2 shadow-sm transition-all focus-within:border-2 focus-within:border-imperial-500 focus-within:bg-imperial-50/30",
          "text-sm text-ink-900 placeholder:text-ink-400 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
      >
        {prefix ? (
          <span className="text-ink-400" aria-hidden="true">
            {prefix}
          </span>
        ) : null}
        <input
          type={type}
          className="flex-1 bg-transparent text-sm text-ink-900 placeholder:text-ink-400 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50"
          ref={ref}
          {...props}
        />
        {suffix ? (
          <span className="text-ink-400" aria-hidden="true">
            {suffix}
          </span>
        ) : null}
      </div>
    );
  }
);

Input.displayName = "Input";
